// removed by extract-text-webpack-plugin
module.exports = {"cube":"Cube__cube__2EK7K","top_side":"Cube__top_side__y_WTK","left_side":"Cube__left_side__2ypPK","right_side":"Cube__right_side__2olVd"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Cube/Cube.scss
// module id = 119
// module chunks = 0